// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-AmazonBanner-module__amazonBanner__ognJf";
var _2 = "assets-js-ViewInvitation-components-Guestlist-AmazonBanner-module__linkIcon__LK84H";
export { _1 as "amazonBanner", _2 as "linkIcon" }
